import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme, SPACING, TYPOGRAPHY } from '../../theme';
import { DotLabel } from '../common';
import { Structure } from '../../types';

interface AddressHeaderProps {
  structure: Structure;
  isClaimed: boolean;
}

export function AddressHeader({ structure, isClaimed }: AddressHeaderProps) {
  const { colors } = useTheme();

  const locationLine =
    [structure.city, structure.state].filter(Boolean).join(', ') +
    (structure.zip ? ` ${structure.zip}` : '');

  return (
    <View style={styles.container}>
      <View style={styles.textCol}>
        <Text style={[styles.address, { color: colors.text }]} numberOfLines={2}>
          {structure.address || 'Unknown Address'}
        </Text>
        <Text style={[styles.location, { color: colors.textSecondary }]} numberOfLines={1}>
          {locationLine}
        </Text>
      </View>
      {/* Dot-label, not a chip: status is a 6px dot plus a word (the same
          treatment the structure sheet uses), never a filled pill. */}
      <DotLabel
        label={isClaimed ? 'Claimed' : 'Unclaimed'}
        variant={isClaimed ? 'progress' : 'muted'}
        style={styles.pill}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: SPACING.xs,
    gap: SPACING.sm,
  },
  textCol: {
    flex: 1,
  },
  // The address IS this screen's title, in the light screenTitle register —
  // the same treatment the structure sheet gives it.
  address: {
    ...TYPOGRAPHY.screenTitle,
  },
  location: {
    ...TYPOGRAPHY.body,
    marginTop: 3,
  },
  pill: {
    alignSelf: 'center',
  },
});
